import axios from 'axios';

/**
 * Global axios response interceptor: when the access/refresh token cookies
 * have both expired (server responds 401), every API call across the app
 * starts failing silently — pages just show empty/error states instead of
 * telling the user their session ended. This clears the stale session and
 * sends them back to sign in instead.
 */
const SESSION_KEYS = [
  'roleID',
  'user_email',
  'email_id',
  'user_id',
  'roleName',
  'instituteId',
  'user',
  'login_source',
  'jhs_return_url',
  'authToken'
];

let interceptorRegistered = false;

export const setupSessionExpiredInterceptor = () => {
  if (interceptorRegistered) return;
  interceptorRegistered = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response ? error.response.status : null;

      if (status === 401 && window.location.pathname !== '/signin') {
        SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
        window.location.href = '/signin';
      }

      return Promise.reject(error);
    }
  );
};

export default setupSessionExpiredInterceptor;
